import React, { ChangeEvent } from "react";

import withTitle from "../withTitle";
import { V2 } from "../../Api";
import DelayInput from "../DelayInput";

interface ICPTListViewState {
    isLoading: boolean | string;
    sortColumn: string;
    sortDirection: string;

    cptCodesFull: any[];
    cptCodes: any[];

    searchValue: string;

    [name: string]: any;
}

class CPTListView extends React.Component<{}, ICPTListViewState> {
    constructor(props: Readonly<{}>) {
        super(props);

        const state: ICPTListViewState = {
            isLoading: true,
            sortColumn: "cpt",
            sortDirection: "asc",

            cptCodesFull: [],
            cptCodes: [],

            searchValue: "",
        };

        this.state = state;

        this.handleElementChanged = this.handleElementChanged.bind(this);
    }

    public async componentDidMount() {
        try {
            const cptCodes = await V2.get<any[]>("glossary/cpt");
            cptCodes.sort((a, b) => a.cpt.localeCompare(b.cpt));

            this.setState({
                isLoading: false,

                cptCodesFull: cptCodes,
                cptCodes: cptCodes,
            });
        }
        catch (e) {
            this.setState({
                isLoading: e.message || e || "Could not load CPT list"
            });
        }
    }

    public render() {
        return (
            <div className="viewer-root">
                <div className="filter-control-box">
                    <DelayInput type="text" className="fill-space" placeholder="Search..." timeout={500} name="searchValue" value={this.state.searchValue} onChangeDelayed={this.handleElementChanged} />
                </div>
                <table className="table-vertical">
                    <thead>
                        <tr>
                            <th className="clickable col-smallest" onClick={() => this.sortByField("cpt")}>Code {this.sortIcon("cpt")}</th>
                            <th className="clickable" onClick={() => this.sortByField("wrvu")}>wRVU {this.sortIcon("wrvu")}</th>
                            <th className="clickable" onClick={() => this.sortByField("name")}>Name {this.sortIcon("name")}</th>
                            <th className="clickable" onClick={() => this.sortByField("description")}>Description {this.sortIcon("description")}</th>
                        </tr>
                    </thead>
                    <thead className="table-vertical-head-small">
                        <tr>
                            <th>CPT Codes</th>
                        </tr>
                    </thead>
                    <tbody>
                        {
                            this.state.isLoading === true
                                ? <tr><td colSpan={4}><div className="spinner spinner-center lds-dual-ring" /></td></tr>
                                : typeof this.state.isLoading === "string"
                                    ? <tr><td colSpan={4}><span className="error-text">{this.state.isLoading}</span></td></tr>
                                    : this.state.cptCodes.map(a => (
                                        <tr key={a.cpt}>
                                            <td className="inline" data-caption="CPT: ">{a.cpt}</td>
                                            <td className="col-right-vt inline" data-caption="wRVU: ">{a.wrvu}</td>
                                            <td className="inline" data-caption="Name: ">{a.name}</td>
                                            <td className="wrap" data-caption="Description: ">{a.description}</td>
                                        </tr>
                                    ))}
                    </tbody>
                </table>
            </div>
        );
    }

    private sortByField(field: string) {
        let codes = this.state.cptCodes;
        const direction = this.state.sortColumn === field && this.state.sortDirection === "asc" ? "desc" : "asc";

        switch (field) {
            case "wrvu":
                codes =
                    direction === "asc"
                        ? codes.sort((a, b) => a.wrvu - b.wrvu)
                        : codes.sort((a, b) => b.wrvu - a.wrvu);
                break;
            case "name":
            case "description":
            case "cpt":
                codes =
                    direction === "asc"
                        ? codes.sort((a: any, b: any) => (a[field] || "").localeCompare(b[field] || ""))
                        : codes.sort((a: any, b: any) => (b[field] || "").localeCompare(a[field] || ""));
                break;
            default:
                break;
        }

        this.setState({
            sortColumn: field,
            sortDirection: direction,
            cptCodes: codes
        });
    }

    private sortIcon(column: string) {
        return this.state.sortColumn === column
            ? <i className={`icon-chevron-${this.state.sortDirection === "asc" ? "up" : "down"} icon-style-smaller`} />
            : undefined
    }

    private handleElementChanged(e: ChangeEvent<HTMLInputElement>) {
        const name = e.currentTarget.name;
        const value = e.currentTarget.value;

        this.setState({
            [name]: value
        }, () => this.filterTable());
    }

    private filterTable() {
        const searchText = this.state.searchValue.toLowerCase();
        const filteredCpts = this.state.cptCodesFull.filter(a => (
            a.cpt.includes(searchText) ||
            a.name.toLowerCase().includes(searchText) ||
            a.description.toLowerCase().includes(searchText)
        ));

        this.setState({
            cptCodes: filteredCpts
        });
    }
}

export default withTitle("CPT List", CPTListView);